import React, {FC, SyntheticEvent, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import StyledDropdown from "../CommonComponents/StyledDropdown/StyledDropdown";
import {AggregationTypes} from "../../types/mamTypes";
import {useTheme} from "../../contexts/theme";
import StyledAutoComplete from "../CommonComponents/StyledAutocomplete/StyledAutocomplete";
import {Competition} from "../../types/competitionTypes";
import TextinputField from "../CommonComponents/TextInputField/TextinputField";
import TransparentButton from "../CommonComponents/TransparentButton/TransparentButton";
import StyledCheckBox from "../CommonComponents/StyledCheckbox/StyledCheckBox";
import StyledCheckBoxLabel from "../CommonComponents/StyledCheckbox/StyledCheckBoxLabel";


interface ClipAggregateOptionsProps {
    typeAggregate: string;
    handleChaneTypeAggregate: (value: string) => void;
    eventsInfo? : {id: string, name: string}[];
    handleChangeEvent: (event:{id: string, name: string}) => void;
    players?: string[];
    handleInsertEvent: (value: string) => void;
    handleChangePlayer: (value: string) => void;
    eventSelected: {id: string, name: string};
    playerSelected: string;
    handleInsertPlayer: (value: string) => void;
    competition?: Competition[]
    competitionSelected?: Competition
    handleChangeCompetition: (competition : Competition) => void;
    selectedMatchDay?: string;
    handleChangeMatchDay: (value: string) => void;
    handleGetTemplates: () => void;
    numbering : boolean;
    handleNumbering: (value: boolean) => void;
    handleCreationHighlight: () => void;
    handleSort: (value: "asc" | "desc") => void;
    sort : "asc" | "desc";
    disableCreateHighlight?: boolean;
}

const ClipAggregateOptions: FC<ClipAggregateOptionsProps> = ({typeAggregate,handleChaneTypeAggregate,
                                                                 eventsInfo,
                                                                 handleChangeEvent,
                                                                 players,
                                                                 handleChangePlayer,
                                                                 eventSelected,
                                                                 playerSelected,
                                                                 handleInsertPlayer,
                                                                 competition,
                                                                 competitionSelected,
                                                                 handleChangeCompetition,
                                                                 handleChangeMatchDay,
                                                                 selectedMatchDay,
                                                                 handleInsertEvent,
                                                                 handleGetTemplates,
                                                                 numbering,
                                                                 handleNumbering,
                                                                 handleCreationHighlight,
                                                                 handleSort,
                                                                 sort,
                                                                 disableCreateHighlight
}) => {

    const theme = useTheme();


    return (<Box sx={{
        paddingTop: theme.spacing.md
    }}>
        <Box sx={{
            paddingBottom: theme.spacing.md,
        }}>
            <Grid container spacing={2} direction={'column'}>
                <Grid item xs={12} md={3}>
                    <StyledDropdown options={Object.values(AggregationTypes)} fullWidth={true} label={"Aggregation Type"} value={typeAggregate} id={"Type Aggregation"} onChange={(e)=>{handleChaneTypeAggregate(e.target.value)}}></StyledDropdown>
                </Grid>
                {(typeAggregate === AggregationTypes.ManOfTheMatch) &&
                    (
                        <>
                            <Grid item xs={12} md={3}>
                                <StyledAutoComplete name={'events'} label={"Choose an Event"} options={eventsInfo ? eventsInfo : []}  valueField={'id'} value={eventSelected} labelField={'name'} multiple={false} onChange={(_,e)=>{handleChangeEvent(e)}} onInputChange={(_,e)=>{handleInsertEvent(e)}}/>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <StyledAutoComplete name={'players'} label={"Choose a Player"} options={players ? players : []} value={playerSelected}  multiple={false} onChange={(_, newValue) => handleChangePlayer(newValue ?? '')} onInputChange={(_,e)=>{handleInsertPlayer(e)}}/>
                            </Grid>
                        </>
                    )
                }

                {(typeAggregate === AggregationTypes.BestOfTheDay && competition !== undefined && competition.length > 0) &&
                    (
                        <>
                            <Grid item xs={12} md={3}>
                                <StyledAutoComplete name={'competitions'} label={"Choose a Competition"} options={competition}  valueField={'id'} value={competitionSelected} labelField={'name'} multiple={false} onChange={(_,e)=>{handleChangeCompetition(e)}}/>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextinputField placeholder='MatchDay' label={'Match Day'} type='number' variant={'outlined'}
                                                value={selectedMatchDay}
                                                size={'medium'}
                                                onChange={(e)=>{handleChangeMatchDay(e.target.value)}}
                                                name={'matchday'} required={true}
                                                id={"outlined-basic"}
                                                borderBottomColor={theme.palette.orange}
                                                color={theme.palette.white}
                                                borderColor={theme.palette.white}
                                                borderRadius={theme.border.width.hard}
                                                fullWidth={true}
                                ></TextinputField>


                            </Grid>
                            <Grid item xs={12} md={3}>
                                <StyledAutoComplete name={'players'} label={"Choose a Player"} options={players ? players : []} value={playerSelected}  multiple={false} onChange={(_, newValue) => handleChangePlayer(newValue ?? '')} onInputChange={(_,e)=>{handleInsertPlayer(e)}}/>
                            </Grid>


                        </>
                    )
                }

                {((typeAggregate === AggregationTypes.GoalParade || typeAggregate === AggregationTypes.BestActionOfTheDay ) && competition !== undefined && competition.length > 0) &&
                    (
                        <>
                            <Grid item xs={12} md={3}>
                                <StyledAutoComplete name={'competitions'} label={"Choose a Competition"} options={competition}  valueField={'id'} value={competitionSelected} labelField={'name'} multiple={false} onChange={(_,e)=>{handleChangeCompetition(e)}}/>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextinputField placeholder='Match Day' label={'Match Day'} type='number' variant={'outlined'}
                                                value={selectedMatchDay}
                                                size={'medium'}
                                                onChange={(e)=>{handleChangeMatchDay(e.target.value)}}
                                                name={'name'} required={true}
                                                id={"outlined-basic"}
                                                borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                                backgroundColor={'none'}
                                                color={theme.palette.white}
                                                borderColor={theme.palette.white}
                                                borderRadius={theme.border.width.hard}

                                ></TextinputField>


                            </Grid>



                        </>
                    )
                }

                {((typeAggregate === AggregationTypes.BestOfTheSeason ) && competition !== undefined && competition.length > 0) &&
                    (
                        <>
                            <Grid item xs={12} md={3}>
                                <StyledAutoComplete name={'competitions'} label={"Choose a Competition"} options={competition}  valueField={'id'} value={competitionSelected} labelField={'name'} multiple={false} onChange={(_,e)=>{handleChangeCompetition(e)}}/>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <StyledAutoComplete name={'players'} label={"Choose a Player"} options={players ? players : []} value={playerSelected}  multiple={false} onChange={(_, newValue) => handleChangePlayer(newValue ?? '')} onInputChange={(_,e)=>{handleInsertPlayer(e)}}/>
                            </Grid>
                        </>
                    )
                }

            </Grid>
            <Box paddingTop={theme.spacing.md}>
                { ((typeAggregate === AggregationTypes.ManOfTheMatch && eventSelected.id !== "" && eventSelected.name !== "" && playerSelected !== "") ||
                    (typeAggregate === AggregationTypes.BestOfTheDay && competitionSelected?.name !== "" && selectedMatchDay !== "" && playerSelected !=="") ||
                    (typeAggregate === AggregationTypes.GoalParade && competitionSelected?.name !== "" && selectedMatchDay !== "") ||
                    (typeAggregate === AggregationTypes.BestOfTheSeason && competitionSelected?.name !== "" && playerSelected !=="") ||
                    (typeAggregate === AggregationTypes.BestActionOfTheDay && competitionSelected?.name !== "" && selectedMatchDay !== "")
                ) ? (<TransparentButton width={'100%'} disabled={false} text={"Get Clips"} type={'button'} onClick={handleGetTemplates}/>) :

                    (<TransparentButton width={'100%'} disabled={true} text={"Get Clips"} type={'button'} onClick={handleGetTemplates}/>)
                }

            </Box>
        </Box>



        <Box paddingTop={theme.spacing.md}>
            <StyledCheckBoxLabel disabled={disableCreateHighlight} iconSize={'30px'} label={"Countdown"} checked={numbering} onChange={() => {handleNumbering(!numbering)}}/>
        </Box>
        <Box paddingTop={theme.spacing.md}>
            <StyledAutoComplete name={'Sort'} label={"Choose a Sort"} disabled={!numbering} options={['asc', 'desc']} value={sort}  multiple={false} onChange={(_, newValue) => handleSort(newValue)}/>
        </Box>
        <Box paddingTop={theme.spacing.md}>
            <TransparentButton width={'100%'} disabled={disableCreateHighlight} text={"Create Highlight"} type={'button'} onClick={handleCreationHighlight}/>
        </Box>

    </Box>)
}

export default ClipAggregateOptions